<template>
  <b-modal
      id="approveModal"
      centered hide-footer
      :title="title"
      ref="approveModal"
  >
    <b-card-text class="text-center">
        <div class="mb-2">
          <template v-if="action == 'send_offer' && invoice.status == 12 && invoice.msg">
              <p><strong style="font-size: 18px; color: red;">{{invoice.msg}}</strong></p>
              <p><strong>{{$t('reminder_offer_problems')}}</strong></p>
          </template>

          <template v-if="usersWithoutAddress.length > 0">
            <div class="alert alert-warning text-left">
              <h5 class="alert-heading">{{ $t('missing_addresses_warning') }}</h5>
              <div class="p-2">
                <p>{{ $t('following_users_missing_addresses') }}:</p>
                <ul class="mb-2">
                  <li v-for="user in usersWithoutAddress" :key="user.id">
                    {{ user.full_name }} (U-{{ user.id }})
                  </li>
                </ul>
                <p class="mb-0">{{ $t('add_addresses_or_send_anyway') }}</p>
              </div>
            </div>
          </template>

          <strong v-if="action != 'send_offer'">
            {{ textContent }}
          </strong>
          <div v-else>
            <select class="form-control z-5 relative custom-border" v-model="acknowledgment">
              <option v-for="item in acknowledgmentTypes" :value="item.id">{{ $t(item.name) }}</option>
            </select>
            <b-form-group v-if="invoice.type !== InvoiceType.NonRecourse" class="mt-1">
              <multiselect
                  v-model="multiselectVal"
                  :options="options"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :placeholder="$t('select_recipients')"
                  label="text"
                  track-by="value"
                  :class="{ 'is-invalid': showValidationError }"
              />
              <div v-if="showValidationError" class="invalid-feedback d-block">
                {{ $t('please_select_at_least_one_user') }}
              </div>
            </b-form-group>
          </div>
        </div>
    </b-card-text>
    <hr />
    <b-row>
      <b-col v-if="typeof showInput != 'undefined'" cols="12">
        <b-form-group
            id="comment-group"
            :label="$t('comment') + ':'"
            label-for="comment">
          <b-form-textarea
              id="comment"
              v-model="showInput"
              required
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>
      <b-col v-if="action == 'remove' || action == 'reject'" cols="12">
        <b-form-group
            id="reason-group"
            :label="$t('comment') + ':'"
            label-for="comment">
          <b-form-textarea
              id="reason"
              v-model="reason"
              required
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>
      <b-col class="text-center">
        <template v-if="usersWithoutAddress.length > 0">
          <b-button variant="secondary" size="sm" @click="$bvModal.hide('approveModal')" class="mr-2">
            {{ $t('cancel') }}
          </b-button>
          <b-button variant="warning" size="sm" @click="sendAnyway()">
            {{ $t('send_anyway') }}
          </b-button>
        </template>
        <template v-else>
          <!-- Normal buttons -->
          <b-button variant="danger" size="sm" @click="$bvModal.hide('approveModal')" class="mr-2">
            <feather-icon icon="XIcon"></feather-icon>
          </b-button>
          <b-button variant="primary" size="sm" @click="approve()">
            <feather-icon icon="CheckIcon"></feather-icon>
          </b-button>
        </template>
      </b-col>
    </b-row>
  </b-modal>

</template>

<script>
import { BModal, BButton,  BCardText, BRow, BCol, BFormGroup, BFormTextarea } from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'
import Ripple from 'vue-ripple-directive'
import InvoiceType from "@/enums/invoiceType";

export default {
  name: "ApproveModal",
  components: {
    BButton,BModal, BCardText, BRow, BCol, BFormGroup, BFormTextarea, Multiselect
  },
  data() {
    return {
      reason: '',
      acknowledgmentTypes: null,
      acknowledgmentLocal: this.invoice?.acknowledgment_type?.id,
      multiselectVal: [],
      options: [],
      InvoiceType,
      showValidationError: false,
      usersWithoutAddress: []
    }
  },
  computed: {
    acknowledgment: {
      get() {
        return this.acknowledgmentLocal ?? this.acknowledgmentTypes?.[0]?.id;
      },
      set(value) {
        this.acknowledgmentLocal = value;
      }
    }
  },
  directives: {
    Ripple,
  },
  props: ['textContent','title','showInput', 'action', 'invoice'],
  created() {
    this.$http.post('/invoice/admin/get-acknowledgment-types').then((res) => {
      this.acknowledgmentTypes = res.data.value;
    });
    if (!this.invoice || !this.invoice.id) {
      return;
    }
    this.$http.get(`company/admin/${this.invoice.id}/users`).then((res)=>{
      res.data.value.all_users.forEach((element) => {
        this.options.push({ text: element.full_name, value: element.id });
      });

      if (res.data.value.selected_users.length > 0) {
        res.data.value.selected_users.forEach((element) => {
          this.multiselectVal.push({ text: element.full_name, value: element.id });
        });
      }
    });
  },
  watch: {
    multiselectVal: {
      handler: async function(newVal) {
        // Only check if we're in send_offer action and not NonRecourse
        if (this.action === 'send_offer' && this.invoice.type !== this.InvoiceType.NonRecourse) {
          if (!newVal || newVal.length === 0) {
            this.usersWithoutAddress = [];
            return;
          }

          // Check if users have addresses
          const userIds = this.parseMultiselectResponse();
          try {
            const response = await this.$http.post('/company/admin/check-user-addresses', {
              user_ids: userIds
            });

            if (response.data.value && response.data.value.users_without_address && response.data.value.users_without_address.length > 0) {
              this.usersWithoutAddress = response.data.value.users_without_address;
            } else {
              this.usersWithoutAddress = [];
            }
          } catch (error) {
            console.error('Error checking user addresses:', error);
            this.usersWithoutAddress = [];
          }
        }
      },
      deep: true
    }
  },
  methods: {
    async approve(){
      if (this.action === 'send_offer') {
        if (this.invoice.type !== this.InvoiceType.NonRecourse) {

          if (!this.multiselectVal || this.multiselectVal.length === 0) {
            this.showValidationError = true;
            return;
          }

          const userIds = this.parseMultiselectResponse();
          try {
            const response = await this.$http.post('/company/admin/check-user-addresses', {
              user_ids: userIds
            });

            if (response.data.value && response.data.value.users_without_address && response.data.value.users_without_address.length > 0) {
              this.usersWithoutAddress = response.data.value.users_without_address;
              return;
            }
          } catch (error) {
            console.error('Error checking user addresses:', error);
          }

          this.showValidationError = false;
        }
      }

      this.proceedWithApproval();
    },

    sendAnyway() {
      this.usersWithoutAddress = [];
      this.proceedWithApproval();
    },

    proceedWithApproval() {
      this.$parent.showInput = this.showInput;
      this.$parent.approve = true;
      this.$parent.reason = this.reason;
      this.$parent.callApproveModalAction(this.acknowledgment, this.parseMultiselectResponse());
      this.$refs['approveModal'].hide()
    },

    parseMultiselectResponse(){
      return this.multiselectVal?.map((item)=>item.value);
    }
  }
}
</script>

<style scoped>
.custom-border {
    border: 1px solid #e8e8e8;
    border-radius: 0.357rem;
}

.is-invalid >>> .multiselect__tags {
    border-color: #dc3545;
}

.invalid-feedback {
    color: #dc3545;
    font-size: 0.857rem;
    margin-top: 0.25rem;
}
</style>
